import { BudgetValidationConfiguration } from "./partials/useBudgetValidationGenerator";

type GrpSubOrderInstanceSettings = {
  validationConfigs: {
    budget: BudgetValidationConfiguration;
  };
};

const useGrpSubOrderSettings = () => {
  const createInstanceSettings = (): GrpSubOrderInstanceSettings => ({
    validationConfigs: {
      budget: {
        minimum: 0,
      },
    },
  });

  return {
    createInstanceSettings,
  };
};

export default useGrpSubOrderSettings;
